<template id="xy-drilldown">

    <section>
        <div class="row ml-3">
        <iframe src ="http://139.59.58.160:3000/#!/admin"  height="600" width="100%" frameBorder="0"></iframe>
        </div>
    </section>
</template>
<script>
    export default {
        name: "xy-drilldown"
    }
</script>
<style>

</style>